import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-approve-modal',
  templateUrl: './approve-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, ButtonModule],
})
export class ApproveModalComponent extends BaseModalComponent<
  { title: string; description: string },
  boolean
> {
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  title: string = '';
  description: string = '';

  submit() {
    this.result = true;
    this.close();
  }
}
